module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAuCAMAAACPpbA7AAAAPFBMVEUAAAD9rwD+rwD7rQD9rQD/tQD7rwD/rwD9rwD/rwD6rwD+rwD9rwD8rQD9rwD8rwD/rwD9rwD6rwD9rwAw2H3IAAAAE3RSTlMA37+AYB9AEO8gcM+wUJ+Qf28wgw5sGAAAAJxJREFUSMft1bsOwyAMheFjoBhyadLy/u/aUKuRaIhw1ohvYfmHIxYD4HUyKkvEJlJScwAo6YUIn66wsPkhjRxO0j/QJMNN73vf+97fu3+5nYdg9y98e5dKRvKZUs0EDpU+mvODMRx6XtOJBRtHRS9TaoKFeHuRQ/pNGWdfinz8sV0Y0FD0T8aFfvRQIf0U6fVTpJcp+l6mqFlGywd0AiupM6Rz0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/Service/list-icon-01.png
// module id = aKID
// module chunks = 0 1 2 3 4 5 6